export const APPLICATION_REQUEST = 'APPLICATION_REQUEST';
export const APPLICATION_REQUEST_SUCCESS = 'APPLICATION_REQUEST_SUCCESS';
export const APPLICATION_REQUEST_FAILURE = 'APPLICATION_REQUEST_FAILURE';
